import { ColDef } from 'ag-grid-community';

export const FirearmManagementColumnDef: ColDef[] = [
  {
    // Firearm ID
    headerName: 'Firearm ID',
    field: 'id',
    resizable: true,
    width: 135,
    filter: 'agTextColumnFilter',
    hide: true
  },
  {
    // Firearm UPC
    headerName: 'Firearm UPC',
    field: 'firearm_upc',
    resizable: true,
    width: 150,
    tooltipField: 'Firearm UPC',
    filter: 'agTextColumnFilter',
  },
  {
    // Firearm Type
    headerName: 'Firearm Type',
    field: 'firearm_type',
    resizable: true,
    width: 150,
    tooltipField: 'firearm_type',
    filter: 'agTextColumnFilter',
  },
  {
    // Manufacture
    headerName: 'Manufacture',
    field: 'manufacture',
    resizable: true,
    flex: 1,
    tooltipField: 'manufacture',
    filter: 'agTextColumnFilter',
  },
  {
    // Importer
    headerName: 'Importer',
    field: 'importer',
    resizable: true,
    width: 200,
    tooltipField: 'importer',
    filter: 'agTextColumnFilter',
  },
  {
    // Model
    headerName: 'Model',
    field: 'model',
    resizable: true,
    width: 200,
    tooltipField: 'model',
    filter: 'agTextColumnFilter',
  },
  {
    // Additional Markings
    headerName: 'Additional Markings',
    field: 'additional_markings',
    resizable: true,
    width: 150,
    tooltipField: 'additional_markings',
    filter: 'agTextColumnFilter',
  },
  {
    // Caliber / Gauge
    headerName: 'Caliber / Gauge',
    field: 'caliber_gauge',
    resizable: true,
    width: 200,
    tooltipField: 'caliber_gauge',
    filter: 'agTextColumnFilter',
  },
];
